import { render, staticRenderFns } from "./VeJwBjggManageModal.vue?vue&type=template&id=1aa0ee25"
import script from "./VeJwBjggManageModal.vue?vue&type=script&lang=js"
export * from "./VeJwBjggManageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports